export const API_ENDPOINTS = {
    LOGIN: '/api/api/login.php',
    REGISTER: '/api/api/register.php',
    FORGOT_PASSWORD:'/api/api/forgot_password.php', // silver gold
    PLAYER_PROFILE:'/api/api/get-player-profile.php',
    FEATURED_PACKAGES:'/api/api/getFeaturedPackages.php',
    PACKAGES:'/api/api/getPackages.php',
    USER_INVOICE:'/api/api/getUserInvoice.php',  
    GET_CHAT:'/api/api/chat-api.php/messages',  
    GET_USERS:'/api/api/getOnlineUsers.php',
    GET_FRIENDS:'/api/api/getFriends.php',
    GET_FRIEND_REQUEST:'/api/api/getFriendRequest.php',
    GET_PLAYERS:'/api/api/getPlayers.php',
    SEND_CHAT:'/api/api/chat-api.php/messages',
    GET_CHARACTERS:'/api/api/getCharacters.php',
    SEND_FRIEND_REQUEST:'/api/api/sendFriendRequest.php',
    ACCEPT_FRIEND_REQUEST:'/api/api/acceptFriendRequest.php',
    DECLINE_FRIEND_REQUEST:'/api/api/declineFriendRequest.php',
    BLOCK_FRIEND:'/api/api/blockFriend.php',
    UNBLOCK_FRIEND:'/api/api/unblockFriend.php',
    BLOCK_FRIEND_LIST:'/api/api/getBlockFriendsList.php',
    GET_MAIL_LIST:'/api/api/getMail',
    POKEMONS:'/api/api/getPokemons.php',
    PLAYER_POKEMONS:'/api/api/getPlayerPokemon.php',
    UPDATE_PLAYERS:'/api/api/addNewPlayer.php',
    ADD_PLAYER_POKEMON:'/api/api/addPlayerPokemon.php',
    NOTIFICATIONS:'/api/api/getNotification.php',
    LOGOUT:'/api/api/logout.php',
    REMOVE_FRIEND:'/api/api/removeFriend.php',
    HOUSE_SELLER:'/api/api/buyHouse.php',
    GET_HOUSE_SELLER:"/api/api/getHouseSell.php",
    USER_BADGE:"/api/api/getUserBadge.php",
    POKEMON_JUDGE:"/api/api/PokemonJudge.php",
    POKEMON_GUID:"/api/api/pokemonGuide.php",
    NOTIFICATION_COUNT:"/api/api/getNotificationCount.php",
    POKEMON_BY_ID:'/api/api/getPokemonProfileById.php',
    BEST_FISHER_OF_THE_DAY:'/api/api/getBestFisherManOfDay.php',
    BEST_FISHER_OF_THE_YESTERDAY:'/api/api/getBestFisherManOfYesterday.php',
    POKEMON_CALCULATOR_IVS:'/api/api/PokemonCalculatorIvs.php',
    GOLD_MARKET:'/api/api/goldMarket.php',
    START_FISHING:'/api/api/startFishing.php',
    TRANSFER_VALUE:'/api/api/transferValueToFriend.php',
    CREATE_MESSAGE:'/api/api/createMessage.php',
    CHANGE_PERSONAL_DATA:'/api/api/changePersonalData.php',
    UPDATE_PASSWORD:'/api/api/changePassword.php',
    UPDATE_EMAIL:'/api/api/changeEmail.php',
    RANK_LIST:'/api/api/getRankList.php',
    UPDATE_PRESENTATION:'/api/api/updatePresentation.php',
    UPDATE_HONORS:'/api/api/Honars.php',
    GET_HONORS:"/api/api/getHonors.php",
    ACCOUNT_SHARE:"/api/api/shareAccount.php",
    BOX_UPDATE:'/api/api/boxUpdate',
    GET_TRAVEL:"/api/api/getTravels.php",
    DUEL_INVITE:"/api/api/duelInvite.php",
    DUEL_ACCEPT:"/api/api/duelAccept.php",
    DUEL_DECLINE:"/api/api/duelCancel.php",
    DUEL_EXPIRE:"/api/api/duelExpire.php",
    DUEL_BY_TRAINER:"/api/api/getDualByTrainerId.php",
    PLAYER_POKEMONS_BY_PLAYER:"/api/api/getPokemonByPlayerName.php",
    GET_ATTACK_LIST:"/api/api/getAttcklist.php",
    DO_ATTACK:"/api/api/doAttack.php",
    GET_ATTACK_LOGS:"/api/api/getAttackLogs.php",
    UPDATE_POKEMON_TEAM:"/api/api/updatePokemonTeam.php",
    GET_ALL_PLAYER_POKEMONS:"/api/api/getAllPlayerPokemons.php",
    ADMIN_GIVE_POKEMON:"/api/api/adminGivePokemon.php",
    ADMIN_GET_ALL_USERS:"/api/api/adminGetAllUsers.php",
    ADMIN_GET_USER_POKEMONS:"/api/api/adminGetUserPokemons.php",
    ADMIN_TAKE_POKEMON:"/api/api/adminTakePokemon.php",
    ADMIN_EDIT_USER:"/api/api/adminEditUser.php",
    ADMIN_ADD_POKEMON_TO_DB:"/api/api/adminAddPokemonToDB.php",
    ADMIN_EDIT_POKEMON_IN_DB:"/api/api/adminEditPokemonInDB.php",
    ADMIN_GET_ALL_POKEMONS:"/api/api/adminGetAllPokemons.php",
    START_MAP_BATTLE:"/api/api/startMapBattle.php",
    FINISH_MAP_BATTLE:"/api/api/finishMapBattle.php",
    GET_POKEDEX_STATS:"/api/api/getPokedexStats.php",
    GET_ALL_POKEMONS_FOR_POKEDEX:"/api/api/getAllPokemonsForPokedex.php",
    HEAL_POKEMON:"/api/api/healPokemon.php",
    COMPLETE_HEALING:"/api/api/completeHealing.php",
    GET_HEALING_STATUS:"/api/api/getHealingStatus.php",
    ADMIN_GET_CHAT_SETTINGS:"/api/api/adminGetChatSettings.php",
    ADMIN_UPDATE_CHAT_SETTINGS:"/api/api/adminUpdateChatSettings.php",
    GET_CHAT_SETTINGS:"/api/api/getChatSettings.php",
    GET_USER_ITEMS:"/api/api/getUserItems.php",
    USE_POKEBALL:"/api/attack/wild/wild-attack_use_pokeball.php",
    USE_POKEBALL_MAP_BATTLE:"/api/api/usePokeballMapBattle.php",
    GET_SHOP_ITEMS:"/api/api/getShopItems.php",
    BUY_ITEM:"/api/api/buyItem.php",
    ADMIN_GET_PAYPAL_SETTINGS:"/api/api/adminGetPaypalSettings.php",
    ADMIN_UPDATE_PAYPAL_SETTINGS:"/api/api/adminUpdatePaypalSettings.php",
    CREATE_PAYPAL_ORDER:"/api/api/createPaypalOrder.php",
    VERIFY_PAYPAL_PAYMENT:"/api/api/verifyPaypalPayment.php",
    GET_MENU_SETTINGS:"/api/api/getMenuSettings.php",
    ADMIN_GET_MENU_SETTINGS:"/api/api/adminGetMenuSettings.php",
    ADMIN_UPDATE_MENU_SETTINGS:"/api/api/adminUpdateMenuSettings.php",
    ADMIN_GET_BATTLE_SETTINGS:"/api/api/adminGetBattleSettings.php",
    ADMIN_UPDATE_BATTLE_SETTINGS:"/api/api/adminUpdateBattleSettings.php",
    GET_BATTLE_SETTINGS:"/api/api/getBattleSettings.php",
    ADMIN_GET_ALL_ATTACKS:"/api/api/adminGetAllAttacks.php",
    ADMIN_UPDATE_POKEMON_ATTACKS:"/api/api/adminUpdatePokemonAttacks.php",
    ADMIN_GET_POKEMON_ATTACKS:"/api/api/adminGetPokemonAttacks.php",
    ADMIN_SAVE_POKEMON_ATTACK:"/api/api/adminSavePokemonAttack.php",
    GET_DAILY_SPINS:"/api/api/getDailySpins.php",
    SPIN_WHEEL:"/api/api/spinWheel.php",
    ADMIN_RESET_GAME:"/api/api/adminResetGame.php",
    ADMIN_INIT_DATABASE:"/api/api/adminInitDatabase.php",
    CHAT_MODERATION:"/api/api/chatModeration.php",
    KEEP_ALIVE:"/api/api/keepAlive.php",
    GET_MISSIONS:"/api/api/getMissions.php",
    CLAIM_MISSION:"/api/api/claimMission.php",
    UPDATE_MISSION_PROGRESS:"/api/api/updateMissionProgress.php",
    // Pokemon Market Endpoints
    GET_MARKET_LISTINGS:"/api/api/getMarketListings.php",
    SELL_POKEMON:"/api/api/sellPokemon.php",
    BUY_POKEMON:"/api/api/buyPokemon.php",
    CANCEL_SALE:"/api/api/cancelSale.php",
    GET_MY_SALES:"/api/api/getMySales.php",
    ADMIN_APPROVE_GOLD_SALE:"/api/api/adminApproveGoldSale.php",
    ADMIN_GET_PENDING_APPROVALS:"/api/api/adminGetPendingApprovals.php",
    ADMIN_GET_MARKET_LOGS:"/api/api/adminGetMarketLogs.php",
    ADMIN_CANCEL_SALE:"/api/api/adminCancelSale.php",
    ADMIN_BUY_WITH_PRICE_CHANGE:"/api/api/adminBuyWithPriceChange.php",
    BID_ON_AUCTION:"/api/api/bidOnAuction.php",
    GET_BACKPACK_ITEMS:"/api/api/getBackpackItems.php",
    SELL_ITEM:"/api/api/sellItem.php",
    // Maps Endpoints
    GET_MAPS:"/api/api/getMaps.php",
    GET_MAP_POINTS:"/api/api/getMapPoints.php",
    ADMIN_CREATE_MAP:"/api/api/adminCreateMap.php",
    ADMIN_UPDATE_MAP:"/api/api/adminUpdateMap.php",
    ADMIN_DELETE_MAP:"/api/api/adminDeleteMap.php",
    ADMIN_CREATE_MAP_POINT:"/api/api/adminCreateMapPoint.php",
    ADMIN_UPDATE_MAP_POINT:"/api/api/adminUpdateMapPoint.php",
    ADMIN_DELETE_MAP_POINT:"/api/api/adminDeleteMapPoint.php",
    ADMIN_ADD_POKEMON_TO_POINT:"/api/api/adminAddPokemonToPoint.php",
    ADMIN_UPDATE_MAP_POINT_POKEMON:"/api/api/adminUpdateMapPointPokemon.php",
    ADMIN_REMOVE_POKEMON_FROM_POINT:"/api/api/adminRemovePokemonFromPoint.php",
    ADMIN_GET_MAP_POINT_POKEMON:"/api/api/adminGetMapPointPokemon.php",
    ADMIN_UPLOAD_MAP_IMAGE:"/api/api/adminUploadMapImage.php",
    ADMIN_GET_CITIES:"/api/api/adminGetCities.php",
    ADMIN_GET_MAPS:"/api/api/adminGetMaps.php",
    ADMIN_GET_MAP_POINTS:"/api/api/adminGetMapPoints.php",
    ADMIN_GET_MAP_IMAGES:"/api/api/adminGetMapImages.php",
    // Trainer Endpoints
    ADMIN_GET_TRAINERS:"/api/api/adminGetTrainers.php",
    ADMIN_CREATE_TRAINER:"/api/api/adminCreateTrainer.php",
    ADMIN_UPDATE_TRAINER:"/api/api/adminUpdateTrainer.php",
    ADMIN_DELETE_TRAINER:"/api/api/adminDeleteTrainer.php",
    ADMIN_ADD_TRAINER_POKEMON:"/api/api/adminAddTrainerPokemon.php",
    ADMIN_DELETE_TRAINER_POKEMON:"/api/api/adminDeleteTrainerPokemon.php",
    ADMIN_ADD_TRAINER_REWARD:"/api/api/adminAddTrainerReward.php",
    ADMIN_DELETE_TRAINER_REWARD:"/api/api/adminDeleteTrainerReward.php",
    START_TRAINER_BATTLE:"/api/api/startTrainerBattle.php",
    FINISH_TRAINER_BATTLE:"/api/api/finishTrainerBattle.php",
    GET_TRAINER_BATTLE:"/api/api/getTrainerBattle.php",
    BANK: '/api/api/bank.php',
    ACHIEVEMENTS: '/api/api/achievements.php',
    SETUP_ACHIEVEMENTS: '/api/api/setup_achievements.php',
    // Evolution Management Endpoints
    ADMIN_GET_POKEMON_EVOLUTIONS: '/api/api/adminGetPokemonEvolutions.php',
    ADMIN_SAVE_POKEMON_EVOLUTION: '/api/api/adminSavePokemonEvolution.php',
    // PVP Admin Endpoints
    ADMIN_GET_PVP_SETTINGS: '/api/api/adminGetPvpSettings.php',
    ADMIN_UPDATE_PVP_SETTINGS: '/api/api/adminUpdatePvpSettings.php',
    ADMIN_GET_AD_TAGS: '/api/api/adminGetAdTags.php',
    ADMIN_UPDATE_AD_TAGS: '/api/api/adminUpdateAdTags.php',
    GET_AD_TAGS: '/api/api/getAdTags.php',
    ADMIN_GET_PVP_REWARDS: '/api/api/adminGetPvpRewards.php',
    ADMIN_UPDATE_PVP_REWARDS: '/api/api/adminUpdatePvpRewards.php',
    ADMIN_GET_PVP_LEADERBOARD: '/api/api/adminGetPvpLeaderboard.php',
    ADMIN_DISTRIBUTE_PVP_REWARDS: '/api/api/adminDistributePvpRewards.php',
    ACCEPT_EVOLUTION: '/api/api/acceptEvolution.php',
    
    // PVP Battle Endpoints
    START_PVP_BATTLE: '/api/api/startPvPBattle.php',
    GET_PVP_BATTLE: '/api/api/getPvPBattle.php',
    ATTACK_PVP: '/api/api/attackPvP.php',
    FINISH_PVP_BATTLE: '/api/api/finishPvPBattle.php',
    SWITCH_PVP_POKEMON: '/api/api/switchPvPPokemon.php',
    // PVP Invitation Endpoints
    CREATE_PVP_INVITATION: '/api/api/createPvPInvitation.php',
    GET_PVP_INVITATIONS: '/api/api/getPvPInvitations.php',
    ACCEPT_PVP_INVITATION: '/api/api/acceptPvPInvitation.php',
    DECLINE_PVP_INVITATION: '/api/api/declinePvPInvitation.php',
    GET_ACTIVE_PVP_BATTLE: '/api/api/getActivePvPBattle.php',
};